import { render, staticRenderFns } from "./LatesCcUpdates.vue?vue&type=template&id=160bd386&scoped=true"
import script from "./LatesCcUpdates.vue?vue&type=script&lang=js"
export * from "./LatesCcUpdates.vue?vue&type=script&lang=js"
import style0 from "./LatesCcUpdates.vue?vue&type=style&index=0&id=160bd386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160bd386",
  null
  
)

export default component.exports